export const PROJECT_ANALYZER_CATEGORY_CONFIG = {
    ENVIRONMENT: {
        name: 'Environnement',
    },
    POSITION: {
        name: 'Positionnement',
    },
    MEANS: {
        name: 'Moyens',
    },
    ENTREPRENEUR: {
        name: 'Equipe',
    },
};
export const PROJECT_ANALYZER_SUB_CATEGORY_CONFIG = {
    MARKET_DEMAND: {
        name: 'Le marché : la demande',
    },
    MARKET_SUPPLY: {
        name: "Le marché : l'offre",
    },
    COMPETITORS: {
        name: 'Les autres forces en présence sur le secteur',
    },
    ENVIRONMENT_SYNTHESIS: {
        name: 'Avis synthétique sur la dynamique du secteur',
    },
    PRODUCT_OR_SERVICE: {
        name: 'Le produit ou le service',
    },
    COMMERCIAL_STRATEGY: {
        name: 'La stratégie commerciale',
    },
    POSITIONING_SYNTHESIS: {
        name: "Avis synthétique sur le positionnement de l'entreprise",
    },
    GOVERNANCE: {
        name: 'La gouvernance, le dirigeant et son équipe',
    },
    OTHER_MEANS: {
        name: 'Les autres moyens',
    },
    MEANS_SYNTHESIS: {
        name: 'Avis synthétique sur les moyens employés par la structure ',
    },
    MOTIVATIONS: {
        name: "Motivations de l'entrepreneur",
    },
    ANALYZE_MOTIVATIONS: {
        name: 'Analyse sur les comptes',
    },
    ANALYZE_FINANCES: {
        name: "Environnement financier de l'entrepreneur",
    },
    SYNTHESIS: {
        name: "Avis synthétique sur la démarche entrepreneuriale\n au regard de la situation personnelle de l'entrepreneur",
    },
    SAVINGS: {
        name: 'Épargne disponible (non investie dans le projet)',
    },
};
//# sourceMappingURL=Config.js.map